module.exports = __webpack_public_path__ + "img/new-hero.ceeb3f1b.jpg";